export default "__VITE_ASSET__Bvyd8st0__"